// import React, { useState } from "react";
// import "./contact.css";

// export default function Contact() {
//   const [status, setStatus] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setStatus("Sending...");

//     const formData = new FormData(e.target);

//     const response = await fetch("https://formspree.io/f/xzdqlbjj", {
//       method: "POST",
//       body: formData,
//       headers: {
//         Accept: "application/json",
//       },
//     });

//     if (response.ok) {
//       setStatus("Message sent successfully!");
//       e.target.reset();
//     } else {
//       setStatus("Something went wrong. Try again.");
//     }
//   };

//   return (
//     <section className="contact-section">

//       <h2>Contact Us</h2>

//       <form onSubmit={handleSubmit} className="contact-form">

//         <input name="name" type="text" placeholder="Your Name" required />

//         <input name="email" type="email" placeholder="Your Email" required />

//         <input name="phone" type="text" placeholder="Phone Number" />

//         <textarea name="message" placeholder="Your Message" rows="6" required />

//         <button type="submit">Send Message</button>

//       </form>

//       {status && <p className="status">{status}</p>}

//     </section>
//   );
// }










import React, { useState } from "react";
import "./contact.css";

export default function Contact() {
    const [status, setStatus] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        setStatus("Sending...");

        const formData = new FormData(e.target);

        const response = await fetch("https://formspree.io/f/xpqegjbl", {
            method: "POST",
            body: formData,
            headers: {
                Accept: "application/json",
            },
        });

        if (response.ok) {
            setStatus("Message sent successfully!");
            e.target.reset();
        } else {
            setStatus("Something went wrong. Try again.");
        }
    };

    return (
        <section className="contact-page" id="contact">

            {/* TITLE */}
            <h2 className="contact-title">
                Schedule Site <span>Visit</span>
            </h2>

            {/* MAIN LAYOUT */}
            <div className="contact-container">

                {/* LEFT - MAP */}
                <div className="contact-map">

                    <iframe
                        title="Pristine Kyra Location"
                        src="https://www.google.com/maps?q=Pristine%20Kyra%2C%20Symbiosis%20Road%2C%20Pune%20411014&output=embed"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                    />

                </div>

                {/* RIGHT - FORM */}
                <div className="contact-form-box">

                    <form onSubmit={handleSubmit} className="contact-form">

                      

                        <input
                            name="name"
                            type="text"
                            placeholder="Your Name"
                            required
                            minLength={2}
                        />

                        <input
                            name="phone"
                            type="tel"
                            placeholder="Phone Number"
                            pattern="^[6-9]\d{9}$"
                            title="Enter a valid 10-digit phone number"
                        />

                        <input
                            name="email"
                            type="email"
                            placeholder="Your Email"
                            required
                            pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                            title="Enter a valid email address"
                        />

  <p>
                            Fill the form and our team will contact you shortly.
                            Get complete details on pricing, floor plans, and availability.
                            Our experts will assist you with a personalized consultation.
                        </p>
                        {/* <textarea
                            name="message"
                            placeholder="Your Message"
                            rows="6"
                            required
                            minLength={10}
                        />
*/}
                        <button type="submit">Send Message</button> 

                    </form>
                    {status && <p className="status">{status}</p>}

                </div>

            </div>
        </section>
    );
}